<template>
  <div class="full d-flex justify-center">
    <div class="breakpoint d-flex align-center justify-center">
      <div class="intro" v-if="!testRunning">
        <div class="temp-log d-flex justify-center mb-3">
          <img
            src="../../assets/img/logo-teman-bakat.png"
            height="100px"
            alt=""
          />
        </div>
        <v-card flat class="rounded-max pa-3 mb-5">
          <div v-if="instruction">
            <p class="text-center">
              {{ instruction.pertanyaan }}
            </p>
            <small class="grey--text"
              >*Pengerjaan journey memiliki batas waktu</small
            >
          </div>
          <v-skeleton-loader
            v-if="!instruction"
            type="list-item-three-line"
          ></v-skeleton-loader>
        </v-card>
        <v-btn rounded color="#1E656C" dark block @click="start"
          >Mulai Journey</v-btn
        >
      </div>
      <div class="intro my-5" v-if="testRunning">
        <div class="d-flex align-center mb-5">
          <div class="temp-bar mr-2">
            <v-progress-linear
              color="#1E656C"
              :value="percent"
              rounded
              class="mr-2"
              height="10"
            ></v-progress-linear>
          </div>
          <div>
            <v-btn
              dark
              fab
              small
              color="#1E656C"
              @click="dialogInstruction = true"
              content="Instruksi"
              v-tippy="{
                arrow: true,
                arrowType: 'round',
                animation: 'fade',
                theme: 'light',
              }"
            >
              <v-icon>mdi-help-circle-outline</v-icon>
            </v-btn>
          </div>
        </div>
        <div v-if="!loadingQuest">
          <div class="d-flex mb-3" v-for="item in question" :key="item.id">
            <div class="quest mr-3">
              <v-card class="pa-3 d-flex align-center card-q">
                {{ item.pertanyaan }}
              </v-card>
            </div>
            <div class="rank">
              <v-card class="wrapper py-2">
                <input
                  type="radio"
                  :name="`${item.id}`"
                  :id="`${item.id}-1`"
                  class="opt1"
                  @click="collectJawaban(item.id, 1)"
                />
                <input
                  type="radio"
                  :name="`${item.id}`"
                  :id="`${item.id}-0`"
                  class="opt2"
                  @click="collectJawaban(item.id, 0)"
                />
                <label :for="`${item.id}-1`" class="option option-1">
                  <span>Y</span>
                </label>
                <label :for="`${item.id}-0`" class="option option-2">
                  <span>T</span>
                </label>
              </v-card>
            </div>
          </div>
        </div>
        <div v-if="loadingQuest">
          <div class="d-flex mb-3" v-for="i in 5" :key="i">
            <div class="quest mr-3">
              <v-skeleton-loader
                class="card-q"
                type="image"
              ></v-skeleton-loader>
            </div>
            <div class="rank">
              <v-skeleton-loader
                class="card-q"
                type="image"
              ></v-skeleton-loader>
            </div>
          </div>
        </div>
        <div class="paginate d-flex justify-center align-center">
          <div v-if="page > 1 && !loadingSubmit">
            <v-btn
              dark
              fab
              small
              class="mr-3"
              color="#1E656C"
              v-if="!loadingPrev"
              @click="getQuestion('prev')"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn
              dark
              fab
              small
              class="mr-3"
              color="#1E656C"
              v-if="loadingPrev"
            >
              <v-progress-circular indeterminate></v-progress-circular>
            </v-btn>
          </div>
          <div v-if="last_page !== page">
            <v-btn
              dark
              fab
              small
              color="#1E656C"
              v-if="!loadingNext"
              @click="getQuestion('next')"
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
            <v-btn
              dark
              fab
              small
              class="mr-3"
              color="#1E656C"
              v-if="loadingNext"
            >
              <v-progress-circular indeterminate></v-progress-circular>
            </v-btn>
          </div>
          <div v-if="last_page == page">
            <v-btn
              dark
              rounded
              color="#1E656C"
              v-if="!loadingNext && !loadingSubmit"
              @click="done()"
            >
              Selesai
            </v-btn>
            <v-btn
              dark
              class="text-capitalize"
              rounded
              color="#1E656C"
              v-if="loadingSubmit"
            >
              <v-progress-circular
                size="20"
                class="mr-2"
                indeterminate
              ></v-progress-circular>
              menyimpan jawaban...
            </v-btn>
            <v-btn
              dark
              fab
              small
              class="mr-3"
              color="#1E656C"
              v-if="loadingNext"
            >
              <v-progress-circular indeterminate></v-progress-circular>
            </v-btn>
          </div>
        </div>
      </div>
      <div v-if="instruction">
        <Instruction
          v-bind:dialogInstruction="dialogInstruction"
          v-bind:data="instruction"
          @close="closeDialog"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Instruction from "../instruction/instruction.vue";
export default {
  name: "tesemosi",
  components: {
    Instruction,
  },
  data() {
    return {
      id: 9,
      instruction: null,
      question: null,
      answer: [],
      iam: null,
      testRunning: false,
      page: 1,
      last_page: null,
      loadingNext: false,
      loadingPrev: false,
      loadingQuest: false,
      loadingSubmit: false,
      percent: 100,
      second: null,
      timerTest: null,
      dialogInstruction: false,
      pickedAnswer: null,
    };
  },
  // eslint-disable-next-line no-unused-vars
  beforeRouteLeave(to, from, next) {
    clearInterval(this.timerTest);
    localStorage.removeItem("user-answer");
    localStorage.removeItem("curent_page");
    localStorage.removeItem("testRunning");
    localStorage.removeItem("last_page");
    localStorage.removeItem("remaining-time");
    next();
  },
  mounted() {
    this.getInstruction();
    let curent_page = parseInt(localStorage.getItem("curent_page"));
    let last_page = localStorage.getItem("last_page");
    if (last_page) {
      this.last_page = last_page;
    }
    if (curent_page) {
      this.page = curent_page;
    }
    this.getQuestion();
    let statusTest = localStorage.getItem("testRunning")
      ? localStorage.getItem("testRunning")
      : false;
    if (statusTest) {
      let isUserAnswered = JSON.parse(localStorage.getItem("user-answer"));
      if (isUserAnswered) {
        this.answer = isUserAnswered;
      }
      this.progresBar();
    }
    this.testRunning = statusTest;
  },
  methods: {
    getInstruction() {
      this.$store
        .dispatch("instruksi", this.id)
        .then((data) => {
          this.instruction = data[0];
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getQuestion(status) {
      if (status == "next") {
        this.loadingNext = true;
        this.page = this.page + 1;
      } else if (status == "prev") {
        this.loadingPrev = true;
        this.page = this.page - 1;
      }
      this.loadingQuest = true;
      localStorage.setItem("curent_page", this.page);
      let data = {
        id: this.id,
        page: this.page,
      };
      this.$store
        .dispatch("question", data)
        .then((data) => {
          window.scrollTo(0, 0);
          this.loadingPrev = false;
          this.loadingNext = false;
          this.second = data.waktu[0].waktu * 60;
          this.loadingQuest = false;
          this.question = data.data;
          this.last_page = data.last_page;
          this.checkPickedAnswer(data.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    checkPickedAnswer(questions) {
      if (JSON.parse(localStorage.getItem("user-answer"))) {
        questions.forEach((element) => {
          let pickedAnswer = JSON.parse(
            localStorage.getItem("user-answer")
          ).find((answer) => answer.id === element.id);
          if (pickedAnswer) {
            setTimeout(() => {
              document.getElementById(
                `${pickedAnswer.id}-${pickedAnswer.answer}`
              ).checked = true;
            }, 200);
          }
        });
      }
    },
    collectJawaban(id, val) {
      let index = null;
      let answer = null;
      answer = this.answer.filter((value) => value.id === id);
      if (answer.length) {
        // jika sudah memilih jawaban
        index = this.answer.findIndex((element) => element.id === id); // Cek keberadaan soal
        this.answer.splice(index, 1); // hapus yang lama
        this.saveToStorage(id, val); // pilihan baru
      } else {
        this.saveToStorage(id, val);
      }
    },
    saveToStorage(id, val) {
      this.answer.push({
        id: id,
        answer: val,
      });
      localStorage.setItem("user-answer", JSON.stringify(this.answer));
    },
    start() {
      this.testRunning = true;
      localStorage.setItem("testRunning", this.testRunning);
      localStorage.setItem("last_page", this.last_page);
      this.progresBar();
    },

    done() {
      let answer = JSON.parse(localStorage.getItem("user-answer"));
      if (answer) {
        this.loadingSubmit = true;
        let result = {};
        answer.map((el) => {
          result[el.id] = el.answer;
        });
        let body = { jawaban: JSON.stringify(result) };
        let data = {
          id: this.id,
          body: body,
        };
        this.$store
          .dispatch("postAnswer", data)
          .then((data) => {
            console.log(data);
            this.loadingSubmit = false;
            // console.log(data.hasil);
            let storage = {
              answer: body,
              result: JSON.stringify(data.hasil.azzingers),
            };
            localStorage.setItem("tesemosi", JSON.stringify(storage));
            clearInterval(this.timerTest);
            localStorage.removeItem("user-answer");
            localStorage.removeItem("curent_page");
            localStorage.removeItem("testRunning");
            localStorage.removeItem("last_page");
            localStorage.removeItem("remaining-time");
            let completedMission = JSON.parse(
              localStorage.getItem("completed")
            );

            if (completedMission) {
              let isAnswered = completedMission.filter((i) => i.id == this.id);
              if (!isAnswered.length) {
                completedMission.push({
                  id: this.id,
                  journey: "Tes Emosi",
                  order: completedMission.length + 1,
                  img: `https://nos.wjv-1.neo.id/temanbakat/misi/icon/${this.id}.png`,
                });
                localStorage.setItem(
                  "completed",
                  JSON.stringify(completedMission)
                );
              }
            } else {
              let mission = [
                {
                  id: this.id,
                  journey: "Tes Emosi",
                  order: 1,
                  img: `https://nos.wjv-1.neo.id/temanbakat/misi/icon/${this.id}.png`,
                },
              ];
              localStorage.setItem("completed", JSON.stringify(mission));
            }
            this.$router.push("/result/tesemosi");
          })
          .catch((err) => {
            console.log(err);
            this.loadingSubmit = false;
          });
      }
    },
    progresBar() {
      let remainingTime = localStorage.getItem("remaining-time"); // waktu tersisa
      let runningTime = null; // detik berjalan
      if (remainingTime) {
        runningTime = remainingTime;
      } else {
        runningTime = this.second;
      }
      this.timerTest = setInterval(() => {
        runningTime--;
        this.percent = (runningTime / this.second) * 100;
        localStorage.setItem("remaining-time", runningTime);
        if (runningTime == 0) {
          clearInterval(this.timerTest);
          this.done();
        }
      }, 1000);
    },
    closeDialog() {
      this.dialogInstruction = false;
    },
  },
};
</script>

<style scoped>
.rank {
  width: 15%;
}
.quest {
  width: 85%;
}
.temp-bar {
  width: 90%;
}

.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}
.wrapper .option {
  display: flex;
  justify-content: center;
  background: #fff;
  width: 40px;
  border-radius: 5px;
  cursor: pointer;
  /* padding: 2px; */
  transition: all 0.3s ease;
  border: 1px solid lightgrey;
}

/* RADIO CUSTOM */
input[type="radio"] {
  display: none;
}
.opt1:checked:checked ~ .option-1,
.opt2:checked:checked ~ .option-2 {
  border-color: #23003a;
  background: #23003a;
}

.wrapper .option span {
  font-size: 20px;
  color: #808080;
  font-weight: bold;
}
.opt1:checked:checked ~ .option-1 span,
.opt2:checked:checked ~ .option-2 span {
  color: #fff;
}
.card-q {
  height: 90px;
}
@media (max-width: 576px) {
  .card-q {
    height: 120px;
  }
}
@media (max-width: 396px) {
  .card-q {
    height: 120px;
  }
  .wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    height: 100%;
  }
}
</style>
